import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Checkbox from '@components/Checkbox'
import { extendObservable } from 'mobx'
import { inject, observer } from 'mobx-react'
import Button from '@components/Button'
import PropTypes from 'prop-types'

class ProjectDeleteModal extends Component {
  static defaultProps = {
    hideButtons: true,
    okText: 'Delete',
    showCloseIcon: false,
    shouldCloseOnOverlayClick: true,
    thinContent: true
  }
  static propTypes = {
    modalStore: PropTypes.object.isRequired,
    projectStore: PropTypes.object.isRequired,
    growlStore: PropTypes.object.isRequired
  }

  constructor (props) {
    super(props)
    extendObservable(this, {
      deletePulse: false
    })
  }

  render () {
    const { projectStore, history, modalStore, growlStore } = this.props
    return (
      <div>
        <div>
          <h2>Delete this project?</h2>
          <p>{projectStore.project.projectName}</p>
        </div>
        <div className='center-text'>
          <Button
            primary
            onClick={async () => {
              try {
                const response = await projectStore.delete({
                  deletePulse: this.deletePulse
                })

                modalStore.close()
                history.push('/project-search')
              } catch (err) {
                growlStore.showError(
                  err,
                  `Couldn't delete project ${projectStore.project.projectName}`
                )
              }
            }}
          >
            Delete
          </Button>
          <Button onClick={modalStore.close}>Cancel</Button>
        </div>
      </div>
    )
  }
}

export default withRouter(
  inject('modalStore', 'growlStore')(observer(ProjectDeleteModal))
)
